<template>
	<UIShModal @close="$emit('confirm', false)" class="modal">
		<div class="main">
			<UIShIcon
				name="x-close"
				class="close"
				@click="$emit('confirm', false)"
			/>
			<UIShIcon name="trash" class="trash" />

			<p>Вы уверены, что хотите удалить груз?</p>

			<div class="buttons">
				<UIShButton
					label="Да, удалить"
					md
					:lg="768"
					fill
					@click="$emit('confirm', true)"
				/>
				<UIShButton
					label="Отмена"
					kind="secondary-color"
					md
					:lg="768"
					fill
					@click="$emit('confirm', false)"
				/>
			</div>
		</div>
	</UIShModal>
</template>

<script setup lang="ts">
const $emit = defineEmits<{
	(e: 'confirm', v: boolean): void;
}>();
</script>

<style lang="scss" scoped>
.modal {
	::v-deep(.modal-wrapper) {
		align-items: flex-end;
	}

	::v-deep(.modal-content) {
		width: 100%;
	}
}

.main {
	width: 100%;
	position: relative;
	padding: 1.1111rem;
	padding-top: 1.7778rem;
	color: var(--color-gray950);
	border-top-left-radius: 1.1111rem;
	border-top-right-radius: 1.1111rem;
	background-color: var(--color-white);
}

.close {
	position: absolute;
	top: 0.6667rem;
	right: 0.6667rem;
	color: var(--color-gray500);
}

.trash {
	display: block;
	width: 1.7778rem;
	height: 1.7778rem;
	margin-inline: auto;
	color: var(--color-gray500);
}

p {
	margin-inline: auto;
	text-align: center;
	margin-top: 0.6667rem;
	max-width: 16.6667rem;
	@include useFont(txls);
}

.buttons {
	display: flex;
	flex-wrap: wrap;
	gap: 0.6667rem;
	align-items: center;
	margin-top: 1.7778rem;
	justify-content: space-between;

	::v-deep(.btn) {
		white-space: nowrap;
	}
}

@include screen768 {
	.modal {
		::v-deep(.modal-wrapper) {
			align-items: center;
		}

		::v-deep(.modal-content) {
			width: auto;
		}
	}

	.main {
		width: 23.3333rem;
		padding: 1.7778rem;
		border-radius: 1.1111rem;
	}

	.trash {
		width: 2.2222rem;
		height: 2.2222rem;
	}

	p {
		max-width: unset;
		@include useFont(dxss);
		margin-top: 1.1111rem;
	}

	.buttons {
		flex-wrap: nowrap;
	}
}
</style>
